import gql from 'graphql-tag'

export const GetSections = gql`
  query GetSections($organizationId: ID!, $ids: [ID!], $prefix: String, $withMapping: Boolean!) {
    sections(input: {
      organizationId: $organizationId,
      ids: $ids,
      prefix: $prefix
    }) {
      count,
      results {
        id,
        createdBy,
        hints,
        name,
        emrMapping @include(if: $withMapping) {
          id,
          name
        },
        pbcSectionFlag
      }
    }
  }
`
